// extracted by mini-css-extract-plugin
export default {"mainParticipantInfo":"MainParticipantInfo_mainParticipantInfo__QXxZx"};